<template>
    <div class="hide_scroll" style="display: flex; gap: 15px; overflow-x: scroll; padding: 0 24px; margin: 0 -24px; overflow-y: hidden;">
        <div style="" v-for="each, i in member_triggers" :key="i">
            <!-- 훈련 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.RETURNING_USER
            || each.trigger_type == TRIGGER_TYPE.ROUTINE_FORMATION
            || each.trigger_type == TRIGGER_TYPE.LURKING_ESCAPE
            || each.trigger_type == TRIGGER_TYPE.JOIN_FORM_COMPLETE_PENDING
            || each.trigger_type == TRIGGER_TYPE.NEW_SIGNUP_TRAINING" style="position: relative; overflow: hidden;" class="common_box" @click="goGround">
                <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
                    <img style="width: 100%; height: 100%; object-fit: cover;" :src="require(`@/assets/img/bottom_modal_back${randomNumber}.png`)" alt="">
                </div>
                <div style="background: linear-gradient(179.62deg, rgba(0, 0, 0, 0.1) 0.33%, #210F03 85.95%); padding: 12px; position: absolute; top: 0; left: 0; z-index: 10; height: 100%; width: 100%;">
                    <div style="background: #210F03CC; width: 105px; height: 24px; text-align: center; line-height: 24px; font-weight: 700; font-size: 12px; color: var(--color-main); border-radius: 8px;">Weekly Mission</div>
                    <div style="margin-top: 7px; color: #fff; font-weight: 900; line-height: 16px;">이번 주 훈련 챌린지 도전!</div>
                    <div style="margin-top: 5px; font-weight: 500; font-size: 12px; line-height: 16px; color: #fff;">매주 새로운 훈련에 참여하고 피드백 받기</div>
                    <div style="display: flex; align-items: center; justify-content: center; gap: 10px; width: 108px; height: 28px; background-color: #fff; border-radius: 12px; margin-top: 10px;">
                        <img style="width: 12px;" :src="require('@/assets/img/bottom_modal_icon12.png')" alt="">
                        <div style="font-weight: 800; font-size: 12px;" >훈련 시작하기</div>
                    </div>
                </div>
            </div>
            <!-- 포지션 찾기 PRO -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.NEW_SIGNUP_POSITION" style="position: relative; overflow: hidden; background-color: #213D51;" class="common_box" @click="showPositionPro">
                <div style="position: absolute; left: 50%; transform: translateX(-50%);">
                    <img style="width: 113px; object-fit: cover;" :src="require(`@/assets/img/bottom_modal_icon13.png`)" alt="">
                </div>
                <div style="position: relative; color: #fff; z-index: 10; text-align: center;">
                    <div class="special_color">PRO</div>
                    <div style="font-weight: 700; margin-top: 12px;">200명의 축구 전문가들의 분석</div>
                    <div style="font-weight: 700; font-size: 12px; margin-top: 10px;" >프로들의 포지션 찾기 PRO</div>
                </div>
            </div>
            <!-- 입단 요청서 마무리 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.JOIN_FORM_LEAVE" style="background-color: #FFF6EA;" class="common_box" @click="completeDraft(each)">
                <div style="display: flex; justify-content: space-between; font-weight: 700; font-size: 12px; color: var(--color-main);">
                    <div>입단 요청서 작성 중</div>
                    <div>{{each.refer_info}}%</div>
                </div>
                <div style="height: 5px; background-color: #FF71111A; border-radius: 12px; margin-top: 8px;;">
                    <div style="height: 5px; background-color: var(--color-main); border-radius: 12px;" :style="{width : each.refer_info + '%'}"></div>
                </div>
                <div style="margin-top: 15px; font-weight: 700;">작성을 완료하고 제안을 받아보세요</div>
                <div style="background-color: #fff; border: 1px solid #FF711180; color: var(--color-main); margin: 0 auto; margin-top: 20px; width: 123px;" class="common_btn">이어쓰기</div>
            </div>
            <!-- 입단 요청서 작성하기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.NEW_SIGNUP_REQUEST" style="background-color: #FFE3D0;" class="common_box align_center" @click="showMakeRequest">
                <div style="background-color: #FF711133;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon1.png')" alt="">
                </div>
                <div class="common_title">입단 요청서를 작성해보세요! ✍️</div>
                <div class="sub_title">망설이지 말고 작성해보세요. 연락이 올 수 있어요</div>
                <div style="width: 179px; background-color: var(--color-main);" class="common_btn">입단 요청서 작성하기</div>
            </div>
            <!-- 부모님 인증받기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.JOIN_APPLY_ATTEMPT_UNVERIFIED" style="background-color: #E9FDF3;" class="common_box align_center" @click="showParentAuth">
                <div style="background-color: #078B5E33;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon2.png')" alt="">
                </div>
                <div style="white-space: nowrap; text-align: center;" class="common_title">부모님 인증을 받으면<br>감독님들에게 연락받을 확률이 더 높아져요</div>
                <div style="width: 185px; background-color: #078B5E;" class="common_btn add_image_btn">
                    <div class="check_wrapper">
                        <img style="width: 7px;" :src="require('@/assets/img/white_check.png')" alt="">
                    </div>
                    <div style="line-height: 24px;">부모님 인증받기</div>
                </div>
            </div>
            <!-- 훈련 영상 피드백 확인하기 -->
            <div v-if="each.type == 33" style="background-color: #E8E7FF;" class="common_box align_center">
               <div style="background-color: #453EE133;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon3.png')" alt="">
                </div>
                <div class="common_title">도착한 훈련 영상 피드백이 있어요</div>
                <div class="sub_title">000 감독님이 훈련 영상에 답변해줬어요!</div>
                <div style="width: 123px; background-color: #453EE1" class="common_btn">확인하기</div>
            </div>
            <!-- 훈련 영상 피드백 요청하기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.AFTER_UPLOAD_FEEDBACK" style="background-color: #F5F5F5;" class="common_box align_center" @click="goGrounFeedBack">
                <div style="background-color: #453EE133;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon4.png')" alt="">
                </div>
                <div style="white-space: nowrap; text-align: center;" class="common_title">방금 올린 훈련 영상,<br>전문가에게 피드백을 요청해보세요</div>
                <div style="width: 185px; background-color: #fff; border: 1px solid #453EE1;" class="common_btn add_image_btn">
                    <div class="check_wrapper">
                        <img style="width: 18px;" :src="require('@/assets/img/bottom_modal_icon5.png')" alt="">
                    </div>
                    <div style="line-height: 24px; color: #453EE1" >피드백 요청하기</div>
                </div>
            </div>
            <!-- 팀 살펴보기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.NEW_SIGNUP_SOCCER" style="background: linear-gradient(270deg, #3D32C5 0%, #6E33E9 100%);" class="common_box align_center" @click="goSoccerTeamPage">
                <div style="background-color: #FFFFFF33;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon6.png')" alt="">
                </div>
                <div style="color: #fff;" class="common_title">고민은 입단만 늦출 뿐! ⏰</div>
                <div style="color: #fff; white-space: nowrap; font-weight: 500;" class="sub_title">고민 말고, 원하는 팀에 과감하게 ‘입단 요청’하세요</div>
                <div style="width: 161px; background-color: #fff;" class="common_btn add_image_btn">
                    <div class="check_wrapper">
                        <img style="width: 13px;" :src="require('@/assets/img/bottom_modal_icon7.png')" alt="">
                    </div>
                    <div style="line-height: 22px; color: #210F03">팀 살펴보기</div>
                </div>
            </div>
            <!-- 어떤 팀인지 확인하기 -->
            <div v-if="each.type == 66" style="background: #F5F5F5;" class="common_box align_center">
                <div style="background-color: #ED3B3C33;" class="common_circle">
                    <img style="width: 22px;" :src="require('@/assets/img/bottom_modal_icon8.png')" alt="">
                </div>
                <div style="white-space: nowrap; text-align: center;" class="common_title">감독님 <sapn style="color: #ED3B3C;">5명</sapn>이<br>입단 요청서를 확인했어요</div>
                <div style="width: 179px; background-color: #fff; border: 1px solid #ed3b3c; color: #ED3B3C;" class="common_btn">어떤 팀인지 확인하기</div>
            </div>
            <!-- 스카우트 제안 도착 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.SCOUT_OFFER_ARRIVED" style="background: #FFEFF0;" class="common_box align_center" @click="showScoutRequest">
                <div style="background-color: #ED3B3C33;" class="common_circle">
                    <img style="width: 14px;" :src="require('@/assets/img/bottom_modal_icon9.png')" alt="">
                </div>
                <div class="common_title">스카우트 제안 도착 💌</div>
                <div class="sub_title">드디어 감독님의 러브콜이 도착했습니다!</div>
                <div style="width: 123px; background-color: #ED3B3C;" class="common_btn" >확인하기</div>
            </div>
            <!-- 내 훈련영상 보기 -->
            <div v-if="each.type == 88" style="background: #FFF7E0;" class="common_box align_center">
                <div style="background-color: #FFBA0033;" class="common_circle">
                    <img style="width: 11px;" :src="require('@/assets/img/bottom_modal_icon10.png')" alt="">
                </div>
                <div class="common_title">성실함이 최고의 재능이죠 ⭐️</div>
                <div class="sub_title">회원님의 꾸준함이 빛을 발하고 있어요!</div>
                <div style="width: 158px; background-color: #fff; border: 1px solid #f3b525; color: #210F03;" class="common_btn">내 훈련영상 보기</div>
            </div>
            <!-- 포인트 충전 -->
            <div v-if="each.type == 99" style="background: #FFF7E0;" class="common_box align_center">
                <div style="background-color: #FFBA0033;" class="common_circle">
                    <img style="width: 16px;" :src="require('@/assets/img/bottom_modal_icon11.png')" alt="">
                </div>
                <div class="common_title">포인트가 부족합니다 😭️</div>
                <div class="sub_title">포인트를 충전하고 선수를 영입해보세요</div>
                <div style="width: 135px; background-color: #fff; border: 1px solid #f3b525; color: #210F03;" class="common_btn">포인트 충전</div>
            </div>
            <!-- 멤버십 시작 -->
            <template v-if="each.trigger_type == TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_MEMBERSHIP">
                <HomeBottomBannerFrame :imgPath="require('@/assets/img/bottom_modal_expert_back1.png')" >
                    <div class="common_text_wrapper" style="justify-content: center; align-items: center; gap: 10px;" @click="goRequestPage">
                        <div style="font-size: 20px; line-height: 24px; font-weight: 900;">선수 영입을 시작할까요?</div>
                        <div style="font-size: 12px; line-height: 16px; font-weight: 500;">입단을 희망하는 유망주 선수를 확인하세요!</div>
                    </div>
                </HomeBottomBannerFrame>
            </template>
            <!--<div v-if="each.trigger_type == TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_MEMBERSHIP" style="background: linear-gradient(106.31deg, #232B34 1.75%, #191E26 100%);" class="common_box align_center">-->
                <!--<div style="background-color: #1C2534; border: 1px solid #4D4D4D" class="common_circle">-->
                    <!--<img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon14.png')" alt="">-->
                <!--</div>-->
                <!--<div style="color: #fff; font-size: 16px; font-weight: 900;" class="common_title">선수 영입을 시작할까요?</div>-->
                <!--<div style="color: #fff; font-weight: 500;" class="sub_title">멤버십에 가입하고 유망주 선수를 확인하세요!</div>-->
                <!--<div class="membership_btn">-->
                    <!--<div>멤버십 시작하기</div>-->
                    <!--<img style="width: 7px;" :src="require('@/assets/img/black_arrow.png')" alt="">-->
                <!--</div>-->
            <!--</div>-->
            <!-- <div v-if="each.trigger_type == TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_MEMBERSHIP" class="common_box" style="padding: 0;">
            <div v-if="true" class="common_box" style="padding: 0;">
                <div style="overflow: hidden; border-radius: 12px; position: absolute; z-index: 1;">
                    <img style="width: 100%; object-fit: cover;" :src="require('@/assets/img/bottom_modal_expert_back1.png')" alt="">
                </div>
                <div style="position: relative; z-index: 2; color: #fff; display: flex; justify-content: center; align-items: center; flex-direction: column; height: 100%;">
                    <div style="font-size: 20px; line-height: 24px; font-weight: 900; margin-top: 10px;">선수 영입을 시작할까요?</div>
                    <div style="margin-top: 5px; font-size: 12px; line-height: 16px; font-weight: 500;">입단을 희망하는 유망주 선수를 확인하세요!</div>
                </div>
            </div> -->
            <!-- 입단 신청서 확인 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.JOIN_APPLICATION_ARRIVED" style="background: #FFEFF0;" class="common_box align_center" @click="showMyRequest">
                <div style="background-color: #ED3B3C33;" class="common_circle">
                    <img style="width: 14px;" :src="require('@/assets/img/bottom_modal_icon9.png')" alt="">
                </div>
                <div class="common_title">입단 신청서 도착 💌</div>
                <div class="sub_title">우리 팀 입단을 희망하는 선수가 있습니다</div>
                <div style="width: 158px; background-color: #ED3B3C;" class="common_btn">입단 신청서 확인</div>
            </div>
            <!-- 메세지 보내기 -->
            <div v-if="each.type == 1111" style="background: #F5F5F5;" class="common_box align_center">
                <div style="background-color: #ED3B3C33;" class="common_circle">
                    <img style="width: 22px;" :src="require('@/assets/img/bottom_modal_icon8.png')" alt="">
                </div>
                <div class="common_title">선수와 마음이 통했어요 💘</div>
                <div class="sub_title">감독님이 관심을 준 선수가 제안을 수락했어요</div>
                <div style="width: 146px; background-color: #fff; border: 1px solid #ed3b3c; color: #ED3B3C;" class="common_btn">메세지 보내기</div>
            </div>
            <!-- 전문가 인증하러 가기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.EXPERT_UNVERIFIED || each.trigger_type == TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_AUTH " style="background-color: #E9FDF3;" class="common_box align_center" @click="goExpertCertificate">
                <div style="background-color: #078B5E33;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon2.png')" alt="">
                </div>
                <div class="common_title">전문가 인증이 필요해요 🎓</div>
                <div class="sub_title">회원님의 자격을 인증해주세요</div>
                <div style="width: 179px; background-color: #078B5E;" class="common_btn">전문가 인증하러 가기</div>
            </div>
            <!-- 테스트 제안하기 -->
            <div v-if="each.type == 1313" style="background-color: #fff;" class="common_box align_center">
                <div style="background-color: #FF711133;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon1.png')" alt="">
                </div>
                <div class="common_title">고민하면 뺏깁니다! ⚡️</div>
                <div class="sub_title">우리 팀에 맞는 선수라면 테스트 제안을 해보세요</div>
                <div style="width: 156px; background-color: var(--color-main);" class="common_btn">테스트 제안하기</div>
            </div>
            <!-- 선수 둘러보기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.LONG_INACTIVITY" style="background-color: #FFF6EA;" class="common_box align_center" @click="goRequestPage">
                <div style="background-color: #FF711133;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon1.png')" alt="">
                </div>
                <div class="common_title">이적시장이 뜨겁습니다 🔥</div>
                <div class="sub_title">그동안 놓친 유망주들을 확인해 보세요</div>
                <div style="width: 146px; background-color: #fff; border: 1px solid var(--color-main); color: var(--color-main);" class="common_btn">선수 둘러보기</div>
            </div>
            <!-- 훈련 영상 피드백 작성하기 -->
            <div v-if="each.trigger_type == TRIGGER_TYPE.GROUND_TRAINING_VIDEO_AFTER || each.trigger_type == TRIGGER_TYPE.EXPERT_APPROVAL_AFTER_FEEDBACK" style="background-color: #F5F5F5;" class="common_box align_center" @click="goGround">
                <div style="background-color: #453EE133;" class="common_circle">
                    <img style="width: 15px;" :src="require('@/assets/img/bottom_modal_icon4.png')" alt="">
                </div>
                <div class="common_title">선수들이 감독님의 조언을 기다려요 📝</div>
                <div class="sub_title">피드백을 주고 포인트도 받아보세요!</div>
                <div style="width: 156px; background-color: #fff; border: 1px solid #453EE1;" class="common_btn add_image_btn">
                    <div style="line-height: 24px; color: #453EE1">피드백 작성하기</div>
                </div>
            </div>
            <template v-if="each.trigger_type == TRIGGER_TYPE.EXPERT_TEAM_REGIST">
                <HomeBottomBannerFrame :imgPath="require('@/assets/img/bottom_modal_expert_back4.png')">
                    <div class="common_text_wrapper" style="justify-content: flex-end; padding-left: 10px; padding-bottom: 12px;" @click="showCustomerSupport">
                        <div style="font-size: 12px; line-height: 20px;">유소년 스카우팅을 시작하는 첫걸음,</div>
                        <div style="font-weight: 700; font-size: 24px; line-height: 28px;">축구팀 등록하기</div>
                    </div>
                </HomeBottomBannerFrame>
            </template>
        </div>
    </div>
</template>

<script>
import {TRIGGER_TYPE} from "../../Constants";
import HomeBottomBannerFrame from '@/components/common/HomeBottombannerFrame'

export default {
    name: 'HomeBottomModalList',
    components: {HomeBottomBannerFrame},
    props: {
        member_triggers : {
            type : Array,
            default : () =>[]
        }
    },
    computed: {
        randomNumber() {
            return Math.floor(Math.random() * 4) + 1;
        },
    },
    data() {
        return {
            TRIGGER_TYPE : TRIGGER_TYPE,
        }
    },
    methods : {
        showCustomerSupport(){
            this.$Util.showChatWithAdmin()
        },
        goExpertCertificate(){
            const is_coach = this.$GlobalStore.loginInfo().is_coach == 1;
            this.$GlobalStore.addModal('ExpertInformation', { isModalBackTransparent: is_coach, isExpert: is_coach, status_bar_text_color : 'white' });
        },
        showMyRequest(){
            this.$GlobalStore.addModal('CurrentScout', { parentType: 'request' })
        },
        completeDraft(each){
            const soccerhow_draft = each.soccerhow_draft;
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { soccerhowDraft: soccerhow_draft, isDraft: true, playerType: soccerhow_draft.player_type })
        },
        goGround(){
            this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        showScoutRequest(){
            if (this.$GlobalStore.loginInfo().is_secret == 1) {
                this.$GlobalStore.addModal('CurrentScoutUserSecret')
            } else {
                this.$GlobalStore.addModal('CurrentScoutUser')
            }
        },
        goGrounFeedBack(){
            this.$router.push({ path: '/view/soccer_learn?is_go_feedback=true&time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        showPositionPro(){
            this.$GlobalStore.addModal('SelectFindPosition')
        },
        goSoccerTeamPage(){
            this.$router.push({ path: '/view/soccer_join?isFromHome=true&time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        goRequestPage(){
            this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
        },
        showMakeRequest(){
            this.$GlobalStore.addModal('MakeFeedSoccerJoin', {
                isModalBackTransparent: true,
                completeAction: () => {},
                transitionName: 'bottom',
                isHaveSwiper: true
            })
        },
        showParentAuth(){
            this.$GlobalStore.addModal('ParentAuth');
        }

    }
}
</script>

<style scoped>
.common_box {
    width: 250px;
    height: 136px;
    flex-shrink: 0;
    border-radius: 12px;
    padding: 12px;
    position: relative;
}

.common_circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.align_center {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
}

.common_title {
    margin-top: 5px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
}

.sub_title {
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    color: #808080;
}

.common_btn {
    padding: 4px 0;
    line-height: 24px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    border-radius: 8px;
    text-align: center;
    margin-top: 5px;
}

.add_image_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.check_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid #fff;
}

.special_color {
    background: conic-gradient(from 180deg at 48.5% 50%, #B8C9D3 -28.12deg, #FBFBFD 26.25deg, #C8D4DA 88.12deg, #FFFFFF 156.58deg, #AEC0CE 191.74deg, #E3E9EE 237.13deg, #FAFBFC 255.19deg, #D6DFE6 310.11deg, #B8C9D3 331.88deg, #FBFBFD 386.25deg);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    font-weight: 900;
    font-size: 50px;
}

.membership_btn {
    width: 211px;
    background: linear-gradient(90deg, #E7A90A 0%, #C37F07 100%);
    border: 1px solid #f3b525;
    color: #210F03;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 13px;
    border-radius: 4px;
    font-weight: 800;
    font-size: 12px;
    margin-top: 10px;
}

.common_text_wrapper {
    position: relative;
    z-index: 2;
    color: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
}
</style>
